import React from "react";
import { Button } from "@/components/ui/button";

interface Props {
  onNoClick: () => void;
  onYesClick: () => void;
}

const SubscriptionCheckStep: React.FC<Props> = ({ onNoClick, onYesClick }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <div className="text-sm text-secondary-n-200">
          You need an active Claude Pro/Max subscription to connect and proceed.
          If you don't have an active subscription,{" "}
          <a
            href="https://claude.ai/upgrade"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-n-500 hover:text-primary-n-400 underline"
          >
            upgrade here
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCheckStep;
